import { Pie, mixins } from "vue-chartjs"

const { reactiveProp } = mixins

const DEFAULT_COLORS = ["#1F77B4", "#FF7F0E", "#2CA02C", "#D62728", "#9467BD", "#8C564B", "#E377C2", "#7F7F7F", "#BCBD22", "#17BECF", "#0EA5E9", "#10B981", "#F59E0B", "#EF4444"]

export default {
    name: "SourcesPieChart",
    extends: Pie,
    mixins: [reactiveProp],
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        chartData: {
            type: Object,
            default: () => ({ labels: [], datasets: [{ data: [] }] })
        },
        reloadPieChart: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        this.renderTheChart()
    },
    methods: {
        getColors(size) {
            const out = []
            for (let i = 0; i < size; i++) {
                out.push(DEFAULT_COLORS[i % DEFAULT_COLORS.length])
            }
            return out
        },
        normalizeChartData() {
            const labels = Array.isArray(this.chartData?.labels) ? this.chartData.labels : []
            const sourceDataset = Array.isArray(this.chartData?.datasets) && this.chartData.datasets.length ? this.chartData.datasets[0] : { data: [] }
            const data = Array.isArray(sourceDataset?.data) ? sourceDataset.data : []

            const colors = this.getColors(Math.max(labels.length, data.length))
            const backgroundColor = Array.isArray(sourceDataset?.backgroundColor) && sourceDataset.backgroundColor.length ? sourceDataset.backgroundColor : colors
            const borderColor = Array.isArray(sourceDataset?.borderColor) && sourceDataset.borderColor.length ? sourceDataset.borderColor : colors
            const hoverBorderColor = Array.isArray(sourceDataset?.hoverBorderColor) && sourceDataset.hoverBorderColor.length ? sourceDataset.hoverBorderColor : borderColor

            return {
                labels,
                datasets: [
                    {
                        ...sourceDataset,
                        data,
                        backgroundColor,
                        borderColor,
                        borderWidth: typeof sourceDataset?.borderWidth === "number" ? sourceDataset.borderWidth : 2,
                        hoverBorderColor,
                        hoverBorderWidth: typeof sourceDataset?.hoverBorderWidth === "number" ? sourceDataset.hoverBorderWidth : 3
                    }
                ]
            }
        },
        renderTheChart() {
            const normalizedData = this.normalizeChartData()
            this.renderChart(normalizedData, this.options || {})
        }
    },
    watch: {
        reloadPieChart: {
            handler() {
                this.renderTheChart()
            }
        },
        chartData: {
            deep: true,
            handler() {
                this.renderTheChart()
            }
        },
        options: {
            deep: true,
            handler() {
                this.renderTheChart()
            }
        }
    }
}
